"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.serverErrors = exports.genericError = exports.errorTranslationIds = void 0;
var _showErrorNotification = require("@ori-events/show-error-notification");
const genericError = exports.genericError = 'genericError';
const serverErrors = exports.serverErrors = {
    operationNotAllowed: 'Operation is not allowed',
    outOfStock: 'Out of stock'
};
/**
 * Maps original error texts to translation IDs
 * used to display error descriptions to the user.
 */ const errorTranslationIds = exports.errorTranslationIds = {
    [genericError]: _showErrorNotification.translationKeys.genericError,
    [serverErrors.operationNotAllowed]: _showErrorNotification.translationKeys.offerIsNotAvailable,
    [serverErrors.outOfStock]: _showErrorNotification.translationKeys.selectedQuantityIsNotAvailable
};
